document.querySelectorAll('.digi-benefits').forEach(section => {

  const track = section.querySelector('.digi-benefits__track');
  const dotsWrap = section.querySelector('.digi-benefits__dots');

  if (!track) return;

  const items = section.querySelectorAll('.digi-benefits__item');

  let current = 0;

  let startX = 0;
  let isDragging = false;

  function isDesktop() {
    return window.innerWidth >= 990;
  }

  function getVisibleItems() {

    if (!isDesktop()) return 1;

    return parseInt(
      getComputedStyle(section.querySelector('.digi-benefits__container'))
        .getPropertyValue('--desktop-columns')
    ) || 4;
  }

  function getMaxIndex() {
    return Math.max(0, items.length - getVisibleItems());
  }

  function buildDots() {

    if (!dotsWrap) return;

    dotsWrap.innerHTML = '';

    const pages = getMaxIndex() + 1;

    if (pages <= 1) {
      dotsWrap.style.display = 'none';
      return;
    }

    dotsWrap.style.display = 'flex';

    for (let i = 0; i < pages; i++) {

      const btn = document.createElement('button');

      btn.className = 'digi-benefits__dot';

      if (i === current) {
        btn.classList.add('active');
      }

      btn.addEventListener('click', () => {
        updateCarousel(i);
      });

      dotsWrap.appendChild(btn);
    }
  }

function updateCarousel(index) {

  const item = section.querySelector('.digi-benefits__item');

  if (!item) return;

  const gap = 12;

  const itemWidth = item.offsetWidth + gap;

  // 👇 offset só mobile
  const offset = isDesktop() ? 0 : 20;

  track.style.transform =
    `translateX(calc(-${index * itemWidth}px + ${offset}px))`;

  const dots = section.querySelectorAll('.digi-benefits__dot');

  dots.forEach(dot => dot.classList.remove('active'));

  if (dots[index]) {
    dots[index].classList.add('active');
  }

  current = index;
}

  // =========================
  // DRAG
  // =========================

  function startDrag(e) {

    isDragging = true;

    startX = e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].clientX;

    track.style.transition = 'none';
  }

  function moveDrag(e) {

    if (!isDragging) return;

    const x = e.type.includes('mouse')
      ? e.pageX
      : e.touches[0].clientX;

    const walk = x - startX;

    const item = section.querySelector('.digi-benefits__item');

    const gap = 12;

    const itemWidth = item.offsetWidth + gap;

    const offset = isDesktop() ? 0 : 20;

    track.style.transform =
      `translateX(${-(current * itemWidth) + walk + offset}px)`;
  }

  function endDrag(e) {

    if (!isDragging) return;

    isDragging = false;

    const endX = e.type.includes('mouse')
      ? e.pageX
      : (e.changedTouches
        ? e.changedTouches[0].clientX
        : startX);

    const diff = endX - startX;

    if (diff < -50 && current < getMaxIndex()) {
      current++;
    }

    if (diff > 50 && current > 0) {
      current--;
    }

    track.style.transition = 'transform 0.4s ease';

    updateCarousel(current);
  }

  // =========================
  // EVENTS
  // =========================

  track.addEventListener('mousedown', startDrag);
  track.addEventListener('mousemove', moveDrag);
  track.addEventListener('mouseup', endDrag);
  track.addEventListener('mouseleave', endDrag);

  track.addEventListener('touchstart', startDrag, { passive: true });
  track.addEventListener('touchmove', moveDrag, { passive: true });
  track.addEventListener('touchend', endDrag);

  // =========================
  // CURSOR DESKTOP
  // =========================

  if (isDesktop()) {

    track.style.cursor = 'grab';

    track.addEventListener('mousedown', () => {
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('mouseup', () => {
      track.style.cursor = 'grab';
    });
  }

  // =========================
  // INIT
  // =========================

  buildDots();

  updateCarousel(0);

  window.addEventListener('resize', () => {

    current = 0;

    buildDots();

    updateCarousel(0);
  });

});